import FormattedMessage from 'I18n/components/FormattedMessage';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIIconButton from 'UIComponents/button/UIIconButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import unescapedText from 'I18n/utils/unescapedText';

// @ts-expect-error no types yet
import MinimizedBetaButton from 'ui-addon-opt/components/MinimizedBetaButton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const defaultTitle = /*#__PURE__*/_jsx(FormattedMessage, {
  message: "epAmplitudeSurvey.feedback.label"
});
const EPSurveyThumbFeedback = ({
  closeFeedbackBadge,
  updateIsPositiveFeedback,
  title = defaultTitle
}) => {
  return /*#__PURE__*/_jsx(MinimizedBetaButton, {
    icon: "none",
    children: /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      justify: "between",
      children: [title, /*#__PURE__*/_jsx(UIIconButton, {
        className: "m-left-3",
        onClick: () => updateIsPositiveFeedback(true),
        tooltip: unescapedText('epAmplitudeSurvey.feedback.thumbsUp'),
        use: "unstyled",
        "aria-label": "thumbsUp",
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "thumbsUp"
        })
      }), /*#__PURE__*/_jsx(UIIconButton, {
        className: "m-x-2",
        onClick: () => updateIsPositiveFeedback(false),
        tooltip: unescapedText('epAmplitudeSurvey.feedback.thumbsDown'),
        use: "unstyled",
        "aria-label": "thumbsDown",
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "thumbsDown"
        })
      }), /*#__PURE__*/_jsx(UIIconButton, {
        className: "m-right-2",
        onClick: () => closeFeedbackBadge(false),
        use: "unstyled",
        size: "extra-small",
        children: /*#__PURE__*/_jsx(UIIcon, {
          name: "remove"
        })
      })]
    })
  });
};
export default EPSurveyThumbFeedback;